import classnames from "classnames";

import Button from "@/components/button/Button.tsx";
import {useCheckoutContext} from "@/components/context/hooks.ts";
import {PaymentMethod, PaymentMethodType} from "@/lib/types/billing.ts";
import {CreditCardDisplay} from "@/pages/billing/payment-method/CreditCardDisplay.tsx";
import {PaypalDisplay} from "@/pages/billing/payment-method/PaypalDisplay.tsx";

import css from "./PaymentMethodDisplay.module.css";

export interface PaymentMethodDisplayProps {
  paymentMethod?: PaymentMethod;
  onEdit: (show: boolean) => void;
  readOnly?: boolean;
  formId?: string;
  onSuccess?: () => void;
}

export const PaymentMethodDisplay = ({
  paymentMethod,
  onEdit,
  readOnly,
  formId,
  onSuccess,
}: PaymentMethodDisplayProps) => {
  const {setRequestInProgress} = useCheckoutContext();

  return (
    <form
      id={formId}
      onSubmit={(e) => {
        e.preventDefault();
        setRequestInProgress(true);
        if (onSuccess) {
          onSuccess();
        }
      }}
    >
      <div
        className={classnames(
          css.PaymentMethodContainer,
          "rounded rounded-3 p-4 d-flex align-items-center justify-content-between"
        )}
      >
        <div>
          {paymentMethod?.pm_type === PaymentMethodType.CREDIT_CARD ? (
            <CreditCardDisplay paymentMethod={paymentMethod} />
          ) : paymentMethod?.pm_type === PaymentMethodType.PAYPAL ? (
            <PaypalDisplay paymentMethod={paymentMethod} />
          ) : (
            <span className="pulse-color-gray-700">No payment method on file.</span>
          )}
        </div>
        {!readOnly && (
          <Button onClick={() => onEdit(true)}>{paymentMethod?.pm_type ? "Update" : "Add"} Payment Method</Button>
        )}
      </div>
    </form>
  );
};
